import React from "react";
import Page from "../templates/trust/trustpage";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>Building Trust | Sustainable Raw Materials | Hirdaramani</title>
        <meta
          name="title"
          content="Building Trust | Sustainable Raw Materials | Hirdaramani"
        />
        <meta
          name="description"
          content="Learn about our Future First approach and our commitment to using certified sustainable raw materials to create a better future."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/trust/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Sustainable Raw Materials" />
        <meta
          property="og:title"
          content="Building Trust | Sustainable Raw Materials | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Learn about our Future First approach and our commitment to using certified sustainable raw materials to create a better future."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/trust/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
